var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]:not(.keep)').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.moveImage = {
	init: function () {
		if ($('.news__entry .entryContent .moveImage').length > 0) {
			$('.news__entry .entry__image').appendTo('.moveImage');
		}
	}
};

site.readMore = {
	init: function () {
		$('#readMore').click(function(e) {
			e.preventDefault();
			$('#longAbstract').removeClass('hideText');
		});
	}
};

site.frontpage = {
	init: function() {
		$(window).on('resize', function() {
			var width = $(window).width();
			if (width <= 767) {
				site.frontpage.isMobile = true;
			} else {
				site.frontpage.isMobile = false;
			}
		}).resize();
	},

	newsheadlines: function() {
		$(window).on('resize', function() {
			checkHeadingHeight();
			newsOwl();
		}).resize();
		function checkHeadingHeight() {
			$('.news__box .title').each(function() {
				var height = $(this)[0].scrollHeight;
				if (height > 30) {
					$(this).siblings('.intro').addClass('short');
				}
			})
		}
		function newsOwl() {
			if ($(window).width() < 768) {
				site.owl.init('.news__boxes', {
					loop: true,
					nav: true,
					dots: false,
					responsive: {
						0: {
							items: 1
						},
						570: {
							items: 2
						}
					},
					navText: ["<div class=\"arrow\"><i class=\"fa fa-angle-left\"></i></div>", "<div class=\"arrow\"><i class=\"fa fa-angle-right\"></i></div>"],
					animateOut: 'fadeOut',
					animateIn: 'fadeIn'
				});
			} else {
				$('.news__boxes').trigger('destroy.owl.carousel');
			}
		}
	}
};

site.news = {
	init: function() {
		if (!$('.paginationControl').length) {
			return;
		}
		var grid = $('.entries');
		grid.infiniteScroll({
			path: 'a.stepper.next',
			append: '.news__single',
			status: '.scroller-status',
			hideNav: '.paginationControl',
			button: '#loadMore',
			history: false,
			loadOnScroll: false
		});

		grid.on( 'append.infiniteScroll', function( event, response, path, items ) {
			const croppieFront = MoyaContainer.get('croppie.front');
			$(items).each(function() {
				let $img = $('.image img', this);
				if ($img.length) {
					croppieFront.addJip($img[0], {jipParentSelector: '.entry', types: 'xs'});
				}
			});
			$( items )
				.css('opacity', 0)
				.css('opacity', 1);
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	site.readMore.init();

	let $readMoreText = $('.readMoreText');
	if ($readMoreText.length) {
		$readMoreText.readmore({
			speed: 400,
			moreLink: '<a href="#" class="readMore">Read more</a>',
			lessLink: false,
			embedCSS: false,
			collapsedHeight: 320
		});
	}

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	if($body.is('.formbuilder')) {
		$('form #datePicker, form #dateTo, form #dateFrom').datepicker({
			changeYear: true,
			yearRange: '-100:+0',
		});
	}
	//$ul.prepend($li);
});
